import { lazy } from 'react'

import { $t } from 'packages/locale'
import { RouteConfig } from 'packages/route'

/**
 * 获取资讯管理路由
 *
 * @returns routes
 */
export const getRoutes: () => RouteConfig[] = () => [
  {
    path: 'admin/hot-news',
    name: 'AdminHotNews',
    getTitle: () => $t('资讯管理'),
    component: lazy(() =>
      import('./pages/admin').then((m) => ({
        default: m.AdminHotNews,
      }))
    ),
  },
]
